const APP_VERSION_META_NAME = "app-version";

const formatAppVersion = (): string =>
  `${__APP_INFO__.name} v${__APP_INFO__.version} (${__APP_INFO__.commitHash})`;

function logAppVersion(): void {
  // eslint-disable-next-line no-console
  console.info(
    `%c ${formatAppVersion()}`,
    "color: #ffffff; background: #000000; font-weight: bold; padding: 2px 6px; border-radius: 3px"
  );
}

function injectAppVersionMeta(): void {
  if (document.querySelector(`meta[name="${APP_VERSION_META_NAME}"]`)) {
    return;
  }

  const meta = document.createElement("meta");

  meta.name = APP_VERSION_META_NAME;
  meta.content = formatAppVersion();

  document.head.appendChild(meta);
}

export function initAppVersion(): void {
  logAppVersion();
  injectAppVersionMeta();
}
